import produce from "immer";
import {
  SET_ALL_USERS,
  TOTAL_RECORD,
  LOADER_STATUS,
  ON_NOTIFY,
  SET_CREATE_USER_MODAL,
  SET_Edit_USER_MODAL,
  GET_ALL_COMPANIES,
  SET_USER_LAST_ACTIVITY,
  GET_ALL_GROUPS
} from "./constants";

export const initialState = {
  loaderStatus: false,
  isModalActive: false,
  users: [],
  companies: [],
  isEditModalActive: false,
  totalRecords: '',
  records: '',
  lastActivity:[],
  groups:[]
};

const userManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_ALL_USERS:
      return {
        ...state,
        users: action.users,
      };
    case TOTAL_RECORD:
      return {
        ...state,
        totalRecords: action.totalRecords,
        records: action.records,
      };
    case SET_CREATE_USER_MODAL:
      return {
        ...state,
        isModalActive: action.isModalActive,
      };
    case SET_Edit_USER_MODAL:
      return {
        ...state,
        isEditModalActive: action.isEditModalActive,
      };
    case GET_ALL_COMPANIES:
      return {
        ...state,
        companies: action.payload,
      };
      case SET_USER_LAST_ACTIVITY:
        return {
          ...state,
          lastActivity: action.payload,
        };

    case ON_NOTIFY:
      return {
        ...state,
        status: action.status,
        msg: action.msg,
      };
    case GET_ALL_GROUPS:
      return {
        ...state,
        groups:action.payload
      }
    default:
      return state;
  }
};

export default userManagementReducer;
